module.exports = __webpack_public_path__ + "img/服务订单.c59955a6.png";